var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    transform: "translate(-13228 -392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 24,
    height: 24,
    transform: "translate(13228 392)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "italic",
    transform: "translate(13224.275 390.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M13.325,19.4,16.465,7.675H14.187a.837.837,0,1,1,0-1.675h6.7a.837.837,0,1,1,0,1.675H18.2L15.058,19.4h2.479a.837.837,0,0,1,0,1.675h-6.7a.837.837,0,0,1,0-1.675Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic1);
export default __webpack_public_path__ + "static/media/italic1.6dbd187494e4c5a7baf58d182870849a.svg";
export { ForwardRef as ReactComponent };